import React from 'react';
import styles from './ProfileHintArrow.module.css';

interface ProfileHintArrowProps {
  /** Localized text shown at the arrow's tail. */
  label: string;
  /** Direction the arrow head points — toward the target control. */
  points: 'inlineStart' | 'inlineEnd';
  /** Fires the underlying control (open cover menu / avatar picker / bio editor). */
  onClick?: () => void;
  /** Absolute placement when the consumer positions it (e.g. beside the avatar). */
  style?: React.CSSProperties;
  className?: string;
}

/**
 * §7.17 profile-completion guidance cue (DEV-1484 follow-up, Skip ruling 2026-07-21).
 * A bouncing arrow that lands its head on an incomplete-profile control (cover /
 * avatar / bio) with the label at the tail. Replaces the l4eProfileHintRing highlight.
 * Rendered only while guidance is active (own profile + item still missing); all three
 * show at once and each clears as its item completes.
 */
export default function ProfileHintArrow({
  label,
  points,
  onClick,
  style,
  className,
}: ProfileHintArrowProps) {
  const cls = [styles.hint, styles[points], className].filter(Boolean).join(' ');
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className={cls}
      style={style}
    >
      <span className={styles.label}>{label}</span>
      <span className={styles.arrowWrap} aria-hidden="true">
        <svg
          className={styles.arrow}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 12h14" />
          <path d="M13 6l6 6-6 6" />
        </svg>
      </span>
    </button>
  );
}
